import { DebugService } from './debug.service.js';

class _CookieService {
  constructor() {
    this.debug = new DebugService('SessionService');
  }

  getCookie(key) {
    return document.cookie
      ?.split('; ')
      ?.find(row => row.startsWith(key))
      ?.split('=')[1];
  }

  removeCookie(key) {
    if (this.getCookie(key)) {
      document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
    }
  }
}

export const CookieService = new _CookieService();
